import { createAction, props } from '@ngrx/store';

export const loadOrderDefaultData = createAction('[OrderDefaultData] Load');
export const loadOrderDefaultDataSuccess = createAction('[OrderDefaultData] Load Success', props<{ response: any }>());
export const loadOrderDefaultDataFailure = createAction('[OrderDefaultData] Load Failure', props<{ error: any }>());
export const loadOrderDefaultDataSuccessByKey = createAction(
  '[OrderDefaultData] Load Success By Key',
  props<{ key: string; response: any }>(),
);
